import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import AppLoader from '@projectK/components/AppLoader';

const ParentAccountInfoMain = (props) => {
  const { isMobile, mobileMode } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import('../MobileComponents/ParentAccountInfoMob');
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/ParentAccountInfoWeb');
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? (
    <LoadedComponent {...props} mode={mobileMode} />
  ) : (
    <AppLoader />
  );
};

export default ParentAccountInfoMain;
